import { render, staticRenderFns } from "./perInfo.vue?vue&type=template&id=d544fb62&scoped=true&"
import script from "./perInfo.vue?vue&type=script&lang=js&"
export * from "./perInfo.vue?vue&type=script&lang=js&"
import style0 from "./perInfo.vue?vue&type=style&index=0&id=d544fb62&prod&lang=less&"
import style1 from "./perInfo.vue?vue&type=style&index=1&id=d544fb62&prod&scoped=scoped&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d544fb62",
  null
  
)

export default component.exports